import { Text, VFlow } from 'bold-ui'
import React from 'react'

import { NewsHeadingSection } from './NewsHeadingSection'

export function NewsInternalEstabilizacaoV54() {
  return (
    <VFlow>
      <NewsHeadingSection title='Versão 5.4.9' id='estabilizacao-5-4-9'>
        <VFlow vSpacing={0.5}>
          <Text component='li'>
            Remodelagem dos filtros das listas temáticas no módulo de Acompanhamento de condições de saúde, visando
            facilitar a usabilidade das temáticas específicas.
          </Text>
          <Text component='li'>Inclusão do filtro e campos de raça/cor no Acompanhamento de condições de saúde.</Text>
          <Text component='li'>
            Inclusão de dados de vacinação nas listas temáticas de desenvolvimento infantil, gestação e puerpério, saúde
            da mulher e pessoa idosa.
          </Text>
          <Text component='li'>
            Inclusão de dicas informando quais códigos SIGTAP/CIAP são considerados para preencher o valor de alguns dos
            campos no Acompanhamento de condições de saúde.
          </Text>
          <Text component='li'>
            Incluída funcionalidade para evitar sobrecarga do sistema ao utilizar o módulo de Acompanhamento de
            condições de saúde, que cancela a busca caso ela demore mais que 5 minutos. Esta função é parametrizável
            pelo administrador da instalação.
          </Text>
          <Text component='li'>
            Alteração para incluir o teste rápido de HBV no campo Hepatite B da lista temática de gestação e puerpério e
            saúde da mulher no Acompanhamento de condições de saúde.
          </Text>
          <Text component='li'>
            Migração do módulo Busca ativa de vacinação ao menu de Acompanhamentos. Ele passará a se chamar
            Acompanhamento de vacinação.
          </Text>
          <Text component='li'>
            Inclusão de campo referente à idade gestacional calculada pela DUM (antigo idade gestacional cronológica)
            durante o primeiro atendimento individual com pré-natal.
          </Text>
          <Text component='li'>
            Cuidados compartilhados agora são automaticamente finalizados por óbito quando o cidadão é marcado como
            falecido. Para cuidados com situação Aguardando, apenas a conduta de recondução de cuidado é permitida.
          </Text>
          <Text component='li'>
            Registros na Garantia do acesso agora possuem um indicador visual quando o cidadão está falecido. Nesses
            casos, o agendamento e a edição são desabilitados, e é permitida apenas a remoção com o motivo: Óbito do
            cidadão.
          </Text>
          <Text component='li'>
            Foi alterada a nomenclatura da funcionalidade Unificação de cadastros para Unificação de prontuários, com o
            objetivo de sensibilizar melhor os usuários sobre o impacto da ação.
          </Text>
          <Text component='li'>
            Correção de erro ao finalizar o atendimento quando realizava o encerramento do pré-natal.
          </Text>
          <Text component='li'>
            Correção de cenário onde é possível salvar uma prescrição sem o campo "Tipo de dose" estar preenchido.
          </Text>
          <Text component='li'>
            Remoção de mensagem incorreta ao salvar a edição de um medicamento de uma prescrição.
          </Text>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.4.8' id='estabilizacao-5-4-8'>
        <VFlow vSpacing={0.5}>
          <Text component='li'>
            Correção de erro relacionado à importação da data de nascimento dos profissionais via CNES.
          </Text>
          <Text component='li'>
            Correção de erro ao realizar a impressão de registros de Visita domiciliar e territorial com origem no MICI
            no Histórico clínico do cidadão.
          </Text>
          <Text component='li'>
            Correção de erro onde não estava sendo possível realizar a seleção de cidadão no Registro tardio de
            atendimento.
          </Text>
          <Text component='li'>
            Correção de erro ao registrar a aplicação de um mesmo imunobiológico, mesma dose e com estratégia diferente
            no Atendimento de vacinação.
          </Text>
          <Text component='li'>
            Correção de cenário onde um alerta era apresentado indevidamente ao tentar finalizar um atendimento,
            indicando inconsistência nos procedimentos.
          </Text>
          <Text component='li'>
            Correção de erro onde uma tela branca era apresentada ao tentar visualizar um Atendimento domiciliar no
            Histórico clínico do cidadão.
          </Text>
          <Text component='li'>
            Correção nos filtros do módulo de Acompanhamento de condições de saúde, onde cidadãos que estavam em risco
            de insegurança alimentar não eram apresentados corretamente.
          </Text>
          <Text component='li'>
            Correção de erro onde a reterritorialização de domicílio era impedida caso o cidadão já não residisse mais
            no local.
          </Text>
          <Text component='li'>
            Realizados ajustes no indicador de atualização em tempo real, que não estava funcionando corretamente, no
            campo data provável do parto ecográfica no Atendimento de pré-natal.
          </Text>
          <Text component='li'>
            Correção de erro no processamento de relatórios na etapa "Higienização do Fato Cidadão do PEC" que acontecia
            em algumas instalações.
          </Text>
          <Text component='li'>Atualização das regras para o registro da aplicação de diversos imunobiológicos.</Text>
        </VFlow>
      </NewsHeadingSection>
    </VFlow>
  )
}
